import type { SYSAction } from "../"
import type { ResultType, ModalDialogState } from "./dialog/dialog"
import {
  _TableRefresh,
  _TableInit,
  _TableRebuild,
  _TableSelectRow,
  _TableSelectHeader,
  _TableSort,
  _TableFilter,
  _TableFilterSelected,
  _TableSetPage,
  _TableCopyRow,
  _TableEditRow,
  _TableSelectEndRow,
  _OpenTableRowHeaderMenu,
  _TableDeleteRow,
  _TableSelectAll,
  _TableEditSaveRow,
  _TableDirectSaveRow,
  _TableEditClose,
  _TableAddRow,
  _TableMoreRow,
  _TableViewRow,
  _TableCloseViewRow,
  _TableDeleteRowFromData,
  //_TableMultipleCopyRow,
  _TableMultipleEditRow,
  _TableMultipleCustomFunction,
  _TableSelectCustomSort,
  _TableSelectFilterSort,
  _TableRefreshDataFromServer,
  _TableSelectCustomFilter,
  _TableSelectAttributeFilter,
  _TableSelectColumnFilter,
  _TableSelectColumnRangeFilter,
  _TableOfflineRetryDeleteRow,
  _TableOfflineRetrySaveRow,
  _TableOfflineHandler,
} from "./table/actions"

export {
  _TableRefresh,
  _TableInit,
  _TableRebuild,
  _TableSelectRow,
  _TableSelectHeader,
  _TableSort,
  _TableFilter,
  _TableFilterSelected,
  _TableSetPage,
  _TableCopyRow,
  _TableDeleteRow,
  _OpenTableRowHeaderMenu,
  _TableEditRow,
  _TableSelectEndRow,
  _TableSelectAll,
  _TableEditSaveRow,
  _TableDirectSaveRow,
  _TableEditClose,
  _TableMoreRow,
  _TableViewRow,
  _TableCloseViewRow,
  _TableAddRow,
  _TableDeleteRowFromData,
  //_TableMultipleCopyRow,
  _TableMultipleCustomFunction,
  _TableMultipleEditRow,
  _TableRefreshDataFromServer,
  _TableSelectCustomSort,
  _TableSelectFilterSort,
  _TableSelectCustomFilter,
  _TableSelectAttributeFilter,
  _TableSelectColumnFilter,
  _TableSelectColumnRangeFilter,
  _TableOfflineRetrySaveRow,
  _TableOfflineRetryDeleteRow,
  _TableOfflineHandler,
}

export const _DialogChanged: SYSAction<DialogChangedParam> = (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  state.ovl.dialogs.SYSModal.instance[value.dialogState.instance].closing = true
  value.dialogState.result = value.result

  if (dialogResolver[value.dialogState.instance]) {
    dialogResolver[value.dialogState.instance](value.result)
    dialogResolver[value.dialogState.instance] = undefined
  }
}

export const _DialogDefaultChanged: SYSAction<{
  default: ResultType
  instance: any
}> = (value, { global }) => {
  let state = global.getState()
  state.ovl.libState.dialog[value.instance].default = value.default
}

let dialogResolver: { [key: string]: (value?: any) => void } = {}
export const DialogResult = (instance: any = undefined) => {
  if (instance === undefined) {
    instance = "SYSModal"
  }
  return new Promise((resolve, reject) => {
    dialogResolver[instance] = resolve
  })
}
export type DialogChangedParam = {
  dialogState: ModalDialogState
  result: ResultType
}
